import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import CSRDReportingGuide from './pages/guides/CSRDReportingGuide';
import ESRSComplianceGuide from './pages/guides/ESRSComplianceGuide';
import DoubleMaterialityGuide from './pages/guides/DoubleMaterialityGuide';
import AIESGReportingGuide from './pages/guides/AIESGReportingGuide';
import FAQPage from './pages/FAQPage';
import CSRDReadinessAssessment from './pages/CSRDReadinessAssessment';

const routes = {
  '/guides/csrd-reporting': <CSRDReportingGuide />,
  '/guides/esrs-compliance': <ESRSComplianceGuide />,
  '/guides/double-materiality-assessment': <DoubleMaterialityGuide />,
  '/guides/ai-esg-reporting': <AIESGReportingGuide />,
  '/faq': <FAQPage />,
  '/csrd-readiness-assessment': <CSRDReadinessAssessment />
};

const currentPath = window.location.pathname;
const page = routes[currentPath] || <App />;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
      {page}
  </React.StrictMode>
);

reportWebVitals();